import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  mainnet,
  sepolia,
  base,
  baseSepolia,
  arbitrum,
  polygon,
} from 'wagmi/chains';

export const config = getDefaultConfig({
  appName: 'Deep42 Geo Research - ERC-8004 Executor',
  projectId: import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID || 'deep42-geo-research',
  chains: [
    // Testnets (for development & testing)
    sepolia,
    baseSepolia,

    // Mainnets (for production payments - REAL FUNDS!)
    mainnet,
    base,
    arbitrum,
    polygon,
  ],
  ssr: false,
});

// Chain metadata for UI display and warnings
export const CHAIN_INFO = {
  1: { name: 'Ethereum', symbol: 'ETH', testnet: false, icon: '⟠', explorerUrl: 'https://etherscan.io' },
  8453: { name: 'Base', symbol: 'ETH', testnet: false, icon: '🔵', explorerUrl: 'https://basescan.org' },
  42161: { name: 'Arbitrum One', symbol: 'ETH', testnet: false, icon: '🔷', explorerUrl: 'https://arbiscan.io' },
  137: { name: 'Polygon', symbol: 'MATIC', testnet: false, icon: '🟣', explorerUrl: 'https://polygonscan.com' },
  11155111: { name: 'Sepolia', symbol: 'ETH', testnet: true, icon: '🧪', explorerUrl: 'https://sepolia.etherscan.io' },
  84532: { name: 'Base Sepolia', symbol: 'ETH', testnet: true, icon: '🧪', explorerUrl: 'https://sepolia.basescan.org' },
  80002: { name: 'Amoy', symbol: 'MATIC', testnet: true, icon: '🧪', explorerUrl: 'https://amoy.polygonscan.com' },
} as const;

export type ChainId = keyof typeof CHAIN_INFO;
